


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Location } from 'vue-router';

@Component
export default class PrivacyBanner extends Vue {
  private showBanner = true;

  private async clickPreferences(location: Location) {
    await this.confirmViewedPrivacyBanner();
    await this.$router.push(location);
  }

  private async dismissBanner() {
    this.showBanner = false;
    await this.confirmViewedPrivacyBanner();
  }

  private async confirmViewedPrivacyBanner() {
    await this.$store.dispatch('globals/closePrivacyBanner');
  }
}
